import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { Route, Switch } from "react-router-dom";
import LandingPage from "../pages/LandingPage/LandingPage";
import SignUp from "../pages/SignUp/SignUp";
import VerifyEmail from "../pages/VerifyEmail/VerifyEmail";
import Login from "../pages/Login/Login";
import Terms from "../pages/Terms/Terms";
import Dashboard from "../pages/Dashboard/Dashboard";
import ViewDocs from "../pages/Dashboard/ViewDocs";
import PrivateRoute from "../components/PrivateRoutes/PrivateRoute";
import AddStaff from "../pages/AddStaff/AddStaff";
import DocumentUpload from "../pages/Products/DocumentUpload";
import ResendEmail from "../pages/ResetPassword/ResendEmail";
import SendNewPassword from "../pages/ResetPassword/SendNewPassword";
import UploadUpdate from "../pages/Products/UploadUpdate";
import UserSettings from "../pages/UserSettings/UserSettings";
import SingleProductPage from "../pages/Dashboard/SingleProductPage";
import Application from "../pages/Certification/Application";
import ApplicationForm from "../pages/Certification/ApplicationForm";
import DeviceUpload from "../pages/Certification/DeviceUpload";
import Payment from "../pages/Payment/Payment";
import TestPayment from "../pages/Payment/TestPayment";
import DeviceUploadApp from "../pages/Certification/DeviceUploadApp";
import DemoPage from "../pages/Demo/DemoPage";
import AllPosApplications from "../pages/Dashboard/AllPosApplications";
import ApplicationForm2 from "../pages/Certification/ApplicationForm2";
import DeviceUploadRenewal from "../pages/Renewal/DeviceUploadRenewal";
import DeviceUploadAppRenewal from "../pages/Renewal/DeviceUploadAppRenewal";
import TestPage from "../pages/TestPage/TestPage";
import TestSuccess from "../pages/TestPage/TestSuccess";
import InputFormDevice from "../pages/Renewal/InputFormDevice";
import InputFormApp from "../pages/Renewal/InputFormApp";
import PosDeviceUpdate from "../pages/Updates/PosDeviceUpdate";
import PosAppUpdate from "../pages/Updates/PosAppUpdate";
import ChangePasswordStaff from "../pages/AddStaff/ChangePasswordStaff";
import NotFound from "../pages/NotFound/NotFound";
import AuthenticateUser from "../pages/Login/AuthenticateUser";
import Home from "../pages/Nip/Home";
import ApiHistory from "../pages/Nip/ApiHistory";
import Credentials from "../pages/Nip/Credentials";
import LiveEnvironment from "../pages/Nip/LiveEnvironment";
import InwardIntegration from "../components/Nip-Integration/Inward/InwardIntegration";
import IntegrationHome from "../components/Nip-Integration/Outward/Integration";
import Migration from "../pages/Nip/Migration/Migration";
import ApplicationsHome from "../components/Nip-Integration/Outward/Home";
import OutwardTest from "../components/Nip-Integration/Outward/OutwardTest";
import SingleIntegration from "../components/Nip-Integration/Outward/SingleIntegration";
import PaymentWithBankTransfer from  "../pages/Payment/PaymentWithBankTransfer";
import TerminalManagement from "../pages/Certification/TerminalManagement";

const Routes = ({ currentUser, isAuthenticated }) => {
  return (
    <React.Fragment>
      <Switch>
        <Route exact path="/" component={LandingPage} />
        <Route exact path="/sign-up" component={SignUp} />
        <Route path="/verify-email" component={VerifyEmail} />
        <Route exact path="/login" component={Login} />
        <Route exact path="/terms-and-conditions" component={Terms} />
        <Route exact path="/password-recovery" component={SendNewPassword} />
        <Route exact path="/reset-password" component={ResendEmail} />
        
        <PrivateRoute exact path="/dashboard" component={Dashboard} />
        <PrivateRoute exact path="/test" component={TestPage} />
        <PrivateRoute exact path="/doc/:id" component={ViewDocs} />
        <PrivateRoute exact path="/docs" component={SingleProductPage} />
        <PrivateRoute exact path="/confirmation" component={DocumentUpload} />
        <PrivateRoute exact path="/update" component={UploadUpdate} />
        <PrivateRoute exact path="/staff" component={AddStaff} />
        <PrivateRoute exact path="/settings" component={UserSettings} />
        <PrivateRoute exact path="/apply" component={Application} />
        <PrivateRoute exact path="/success" component={TestSuccess} />
        <PrivateRoute
          exact
          path="/device/details"
          component={ApplicationForm}
        />
        <PrivateRoute
          exact
          path="/application/details"
          component={ApplicationForm2}
        />
        <PrivateRoute exact path="/device/upload" component={DeviceUpload} />
        <PrivateRoute
          exact
          path="/device/renewal"
          component={DeviceUploadRenewal}
        />
        <PrivateRoute
          exact
          path="/device/renewal/details"
          component={InputFormDevice}
        />
        <PrivateRoute exact path="/device/update" component={PosDeviceUpdate} />
        <PrivateRoute
          exact
          path="/application/upload"
          component={DeviceUploadApp}
        />
        <PrivateRoute
          exact
          path="/application/renewal"
          component={DeviceUploadAppRenewal}
        />
        <PrivateRoute
          exact
          path="/application/renewal/details"
          component={InputFormApp}
        />
        <PrivateRoute
          exact
          path="/application/update"
          component={PosAppUpdate}
        />
        <PrivateRoute exact path="/payment" component={Payment} />
        <PrivateRoute exact path="/payment-with-bank-transfer" component={PaymentWithBankTransfer} />
        <PrivateRoute exact path="/payment-testcard" component={TestPayment} />
        <PrivateRoute exact path="/terminal-management" component={TerminalManagement} />
        <PrivateRoute exact path="/test" component={TestPage} />
        <PrivateRoute exact path="/demo" component={DemoPage} />
        <PrivateRoute
          exact
          path="/applications"
          component={AllPosApplications}
        />
        <PrivateRoute
          exact
          path="/user/verify"
          component={ChangePasswordStaff}
        />
        <PrivateRoute exact path="/nip/home" component={Home} />
        <PrivateRoute
          exact
          path="/nip/integration"
          component={ApplicationsHome}
        />
        <PrivateRoute
          exact
          path="/nip/integration/migration"
          component={Migration}
        />
        <PrivateRoute
          exact
          path="/nip/integration/onboarding"
          component={IntegrationHome}
        />
        <PrivateRoute
          exact
          path="/nip/integration/:id"
          component={SingleIntegration}
        />
        <PrivateRoute
          exact
          path="/nip/integration/test/outward"
          component={OutwardTest}
        />
        <PrivateRoute exact path="/nip/history" component={ApiHistory} />
        <PrivateRoute exact path="/nip/credentials" component={Credentials} />
        <PrivateRoute
          exact
          path="/nip/integration/test/inward"
          component={InwardIntegration}
        />
        <PrivateRoute
          exact
          path="/nip/environment/live"
          component={LiveEnvironment}
        />
        <Route exact path="/authenticate" component={AuthenticateUser} />
        <Route exact path="*" component={NotFound} />
      </Switch>
    </React.Fragment>
  );
};

Routes.propTypes = {
  currentUser: PropTypes.any,
  isAuthenticated: PropTypes.any,
  logOutUser: PropTypes.any,
  refreshUserToken: PropTypes.func,
};

const mapStateToProps = (state) => ({
  currentUser: state.auth.currentUser,
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps)(Routes);
